import { tw } from "@careinfo/tailwind";
import { useContext, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { responsiveClassName } from "../../utils/classNames";
import {
  NOTIFICATION_OFFSET,
  NOTIFICATION_TYPE,
  READ,
  UNREAD,
} from "./constants";
import { NotificationContext } from "./context";
import NewChat from "./Chat/NewChat";
import usePostHook from "../../customHooks/usePostHook";
import APIS from "../../constant/Endpoint";
import Switch from "../Switch";

export function NotificationHeader({ active }) {
  const {
    handleReadAll,
    handleSearch,
    searchTerm,
    resetNotifications,
    setOpenInbox,
  } = useContext(NotificationContext);

  const [searchParams, setSearchParams] = useSearchParams();
  const [is_groupTypePrivate, setIsGroupTypePrivate] = useState(true);
  const [selectedUserIds, setSelectedUserIds] = useState([]);

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["group"],
  });
  const handleSwitch = (v: boolean) => {
    resetNotifications();
    setTimeout(() => {
      const clonedSearchParams = new URLSearchParams(searchParams);
      if (v) clonedSearchParams.set(NOTIFICATION_TYPE, UNREAD);
      else clonedSearchParams.set(NOTIFICATION_TYPE, READ);
      clonedSearchParams.set(NOTIFICATION_OFFSET, "0");
      setSearchParams(clonedSearchParams);
    }, 0);
  };

  const handleCreateGroup = async (reset, users, is_private, values) => {
    const url = APIS.GROUP;
    const formData = {
      users: users,
      is_private: is_private,
      name: values?.name,
    };
    try {
      const res = await mutateAsync({ url, formData, setError: () => {} });
      if (res?.status === 201) {
        setOpenInbox({ open: true, group: res?.data });
        reset();
        setIsGroupTypePrivate(true);
        setSelectedUserIds([]);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleCreateSupportGroup = async () => {
    const url = APIS.GROUP;
    const formData = {
      is_private: false,
      users: [],
    };
    try {
      const res = await mutateAsync({ url, formData, setError: () => {} });
      if (res?.status === 201) {
        setOpenInbox({ open: true, group: { ...res?.data, name: "Support" } });
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className={tw`flex gap-x-2 items-center justify-between px-4 py-2`}>
      <label
        htmlFor="notification-search"
        className={responsiveClassName(
          "px-2 bg-white flex items-center border w-32",
          "px-2 bg-white flex items-center border w-40"
        )}
      >
        {" "}
        <input
          type="text"
          id="notification-search"
          className={tw`bg-transparent py-1 focus:outline-none w-full`}
          placeholder="search"
          value={searchTerm}
          onChange={(e) => {
            handleSearch(e.target.value);
          }}
        />
        <span className={tw`inline-block w-4 h-4`}>
          <SearchIcon />
        </span>
      </label>
      {active === "notification" ? (
        <>
          <div className={tw`flex items-center gap-x-2`}>
            <div className={tw`flex`}>
              <Switch
                checked={searchParams.get(NOTIFICATION_TYPE) !== READ || false}
                onChange={handleSwitch}
              />
              &nbsp;
              <span>Unread</span>&nbsp;
            </div>
          </div>
          <button
            className={tw`focus:outline-none ${
              searchParams.get(NOTIFICATION_TYPE) !== UNREAD &&
              "text-gray-400 cursor-not-allowed pointer-events-none"
            }`}
            onClick={handleReadAll}
          >
            Read All
          </button>
        </>
      ) : active === "chat" ? (
        <NewChat
          handleCreateGroup={handleCreateGroup}
          is_groupTypePrivate={is_groupTypePrivate}
          setIsGroupTypePrivate={setIsGroupTypePrivate}
          selectedUserIds={selectedUserIds}
          setSelectedUserIds={setSelectedUserIds}
          handleCreateSupportGroup={handleCreateSupportGroup}
        />
      ) : null}
    </div>
  );
}

function SearchIcon() {
  return (
    <svg viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.47917 10.6667C9.50421 10.6667 11.1458 9.02504 11.1458 7C11.1458 4.97495 9.50421 3.33333 7.47917 3.33333C5.45412 3.33333 3.8125 4.97495 3.8125 7C3.8125 9.02504 5.45412 10.6667 7.47917 10.6667Z"
        stroke="#949494"
        strokeWidth="2"
      />
      <path
        d="M10.7539 10L13.1446 12.3907"
        stroke="#949494"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
